// AI Routes
export const aiRoute = "ai";

// Live Update Routes
export const liveUpdateRoute = "live-updates";

// Tenant-wide command palette search
export const searchRoute = "search";

// Intake Routes
export const meatRoute = "meats";
export const ingredientRoute = "ingredients";
export const ingredientImportRoute = "ingredient-imports";
export const deliveryRoute = "deliveries";
export const deliveryItemRoute = "delivery-items";
export const packagingRoute = "packaging";
export const intakeTraceRoute = "intake-trace";

// Location and Mapping Routes
export const locationRoute = "locations";
export const mapsRoute = "maps";

// Department Routes
export const departmentRoute = "departments";

// Supplier Routes
export const supplierRoute = "suppliers";

// Customer Routes
export const customerRoute = "customers";

// Vehicle Routes
export const vehicleRoute = "vehicles";
export const vanCheckRoute = "van-checks";

// User and Control Routes
export const userRoute = "users";
export const userControlRoute = "control/users";

// User Clock Event Routes
export const userClockEventRoute = "user-clock-events";

// Client Routes
export const clientRoute = "client";

// Tawk.to Routes
export const tawkRoute = "tawk";

// HACCP Plan Routes
export const haccpPlanRoute = "haccp-plans";

// Audit Routes
export const auditRoute = "audits";

// Product Routes
export const productRoute = "products";

// Issue Routes
export const issueRoute = "issues";

// Complaint Routes
export const complaintRoute = "complaints";

// Food Record Routes
export const foodRecordRoute = "food-records";
export const foodRecordItemRoute = "food-record-items";

// Menu Item Routes
export const menuItemRoute = "menu-items";

// Menu Routes (typed menus with categories — allergens-menus spec)
export const menuRoute = "menus";

// File and Storage Routes
export const fileRoute = "files";
export const storageRoute = "storage";

// Temperature Routes
export const temperatureLocationRoute = "temperature/temperature-locations";
export const temperatureLogRoute = "temperature-logs";

// Sensor Log Routes
export const sensorLogRoute = "sensor-logs";

// Check Routes
export const checkRoute = "checks";
export const checkFormRoute = "check-forms";
export const checkScheduleRoute = "check-schedules";

// Stock Routes
export const stockRoute = "stocks";
export const stockDataRoute = "data/stocks";
export const stockOperationRoute = "stock-operations";

// Wastage Routes
export const wastageRoute = "wastages";

// Recipe Routes
export const recipeRoute = "recipes";

// Production Context Route — server-assembled view of recipes + stocks + intakes + suppliers
export const productionContextRoute = "production-context";

// Production Run Route — atomic multi-recipe commit (FIFO server-side allocation, idempotency-key dedup)
export const productionRunRoute = "production-runs";

// Report Routes
export const reportRoute = "reports";

// Training Routes
export const trainingCourseRoute = "training-courses";
export const trainingAssignmentRoute = "training-assignments";
export const trainingRecordRoute = "training-records";

// Rota Management Routes
export const shiftRoute = "shifts";
export const rotaEntryRoute = "rota-entries";

// Dispatch Routes
export const dispatchRoute = "dispatches";

// Form Library Routes
export const formLibraryRoute = "form-library";

// Announcement Routes
export const announcementRoute = "announcements";

// Label Template Routes — HTML/CSS templates rendered server-side via Gotenberg
export const labelTemplateRoute = "label-templates";
